(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["latest_drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('st-latest-drop')) {
    customElements.define('st-latest-drop', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.rail = this.querySelector('[data-drop-rail]');
        if (!this.rail) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.prev = this.querySelector('[data-drop-prev]');
        this.next = this.querySelector('[data-drop-next]');
        this.controls = this.querySelector('[data-drop-controls]');
        this.loadLink = this.querySelector('[data-drop-load]');
        this.status = this.querySelector('[data-drop-status]');
        this.onScroll = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.rail.addEventListener('scroll', this.onScroll, { ...options, passive: true });
        this.prev?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.loadLink?.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); this.loadMore();
        }, options);
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            const rtl = getComputedStyle(this.rail).direction === 'rtl';
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          }
        }, options);
        this.observer = new ResizeObserver(this.onScroll);
        this.observer.observe(this.rail);
        this.hoverQuery = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
        this.addEventListener('pointerenter', event => {
          if (event.target.matches?.('[data-drop-item]') && event.pointerType === 'mouse') this.startPreview(event.target);
        }, { ...options, capture: true });
        this.addEventListener('pointerleave', event => {
          if (event.target === this.previewCard) this.stopPreview();
        }, { ...options, capture: true });
        this.addEventListener('focusin', () => this.stopPreview(), options);
        this.addEventListener('click', () => this.stopPreview(false), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stopPreview();
        }, options);
        this.hoverQuery.addEventListener('change', () => this.stopPreview(), options);
        this.update();
      }
      startPreview(card) {
        this.stopPreview();
        if (!this.hoverQuery.matches || document.hidden) return;
        const gallery = card.querySelector('.card-gallery slideshow-component');
        if (!gallery || typeof gallery.select !== 'function') return;
        // Use only images already supplied by Horizon; leave hidden variant media alone.
        const slides = [...gallery.querySelectorAll('slideshow-slide')].filter(slide =>
          slide.closest('slideshow-component') === gallery &&
          !slide.hasAttribute('hidden') &&
          slide.classList.contains('product-media-container--image')
        );
        if (slides.length < 2) return;
        this.previewCard = card;
        this.previewGallery = gallery;
        this.previewOriginal = gallery.slides?.[gallery.current]?.getAttribute('slide-id');
        this.previewTimer = setInterval(() => {
          if (!card.isConnected || !card.matches(':hover') || !this.hoverQuery.matches || document.hidden) {
            this.stopPreview(); return;
          }
          const current = gallery.slides?.[gallery.current];
          const next = slides[(slides.indexOf(current) + 1) % slides.length];
          const id = next.getAttribute('slide-id');
          if (id) gallery.select({ id }, undefined, { animate: true });
        }, 1600);
      }
      stopPreview(reset = true) {
        clearInterval(this.previewTimer);
        if (reset && this.previewGallery?.isConnected && this.previewOriginal) {
          this.previewGallery.select({ id: this.previewOriginal }, undefined, { animate: false });
        }
        this.previewCard = null; this.previewGallery = null; this.previewOriginal = null;
      }
      disconnectedCallback() {
        this.stopPreview(false);
        this.abort?.abort(); this.abort = null;
        this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = 0;
      }
      update() {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const position = Math.abs(this.rail.scrollLeft);
        if (this.controls) this.controls.hidden = max < 2;
        if (this.prev) this.prev.disabled = position < 2;
        if (this.next) this.next.disabled = position >= max - 2;
      }
      move(direction) {
        const first = this.rail.querySelector('[data-drop-item]');
        if (!first) return;
        const style = getComputedStyle(this.rail);
        const step = first.getBoundingClientRect().width + parseFloat(style.columnGap || 0);
        this.rail.scrollBy({
          left: step * direction * (style.direction === 'rtl' ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
      async loadMore() {
        if (this.loading || !this.loadLink?.getAttribute('href')) return;
        this.loading = true;
        this.loadLink.setAttribute('aria-disabled', 'true');
        this.status.textContent = 'Loading more products…';
        try {
          const url = new URL(this.loadLink.href);
          url.hash = ''; url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url, { signal: this.abort.signal });
          if (!response.ok) throw new Error('Section request failed');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = documentFragment.getElementById(this.id);
          const items = incoming?.querySelectorAll('[data-drop-item]');
          if (!items?.length) throw new Error('No product cards returned');
          const existing = new Set([...this.rail.children].map(item => item.dataset.productId));
          let added = 0;
          items.forEach(item => {
            if (!existing.has(item.dataset.productId)) {
              this.rail.append(document.importNode(item, true)); added++;
            }
          });
          const nextURL = incoming.querySelector('[data-drop-load]')?.getAttribute('href');
          if (nextURL) this.loadLink.setAttribute('href', nextURL);
          else {
            /* Move keyboard focus before hiding the focused load-more link. */
            if (document.activeElement === this.loadLink) this.rail.focus({ preventScroll: true });
            this.loadLink.parentElement.hidden = true;
            this.loadLink.removeAttribute('href');
          }
          this.status.textContent = `${added} more products loaded.`;
          this.update();
        } catch (error) {
          if (error.name !== 'AbortError') this.status.textContent = 'Could not load more products. Please try again or use View All.';
        } finally {
          this.loading = false; this.loadLink?.removeAttribute('aria-disabled');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shifttheoryworld"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('stw-cinematic')) {
    customElements.define('stw-cinematic', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.wall = this.querySelector('.stw__wall');
        this.reveal = this.querySelector('[data-stw-reveal]');
        if (!this.wall || !this.reveal) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.nearby = true;
        this.needsMeasure = true;
        this.schedule = () => {
          if (this.frame || !this.isConnected) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            if (this.needsMeasure) this.measure();
            this.draw();
          });
        };
        this.invalidate = () => { this.needsMeasure = true; this.schedule(); };
        window.addEventListener('scroll', () => {
          if (this.nearby) this.schedule();
        }, { ...options, passive: true });
        document.addEventListener('scroll', () => {
          if (this.nearby) this.schedule();
        }, { ...options, capture: true, passive: true });
        window.addEventListener('resize', this.invalidate, { ...options, passive: true });
        window.addEventListener('pageshow', this.invalidate, options);
        window.addEventListener('load', this.invalidate, options);
        this.reduced.addEventListener('change', this.invalidate, options);
        this.mobile.addEventListener('change', this.invalidate, options);
        this.addEventListener('load', this.invalidate, { ...options, capture: true });
        this.querySelector('[data-stw-down]')?.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          // Never focus the full hero: theme focus effects can cover its image.
          // Native scrolling also works inside the Theme Editor's scroll container.
          const image = this.reveal.querySelector('img');
          if (image) image.loading = 'eager';
          this.reveal.scrollIntoView({
            block: 'start', inline: 'nearest',
            behavior: this.reduced.matches ? 'instant' : 'smooth'
          });
          this.invalidate();
        }, options);
        // Cache the distance between panels; scroll frames read the live hero position.
        this.resizeObserver = new ResizeObserver(this.invalidate);
        this.resizeObserver.observe(this);
        if (document.body) this.resizeObserver.observe(document.body);
        this.intersectionObserver = new IntersectionObserver(entries => {
          this.nearby = entries[0].isIntersecting;
          if (this.nearby) this.invalidate();
        }, { rootMargin: '50% 0px' });
        this.intersectionObserver.observe(this);
        document.fonts?.ready.then(() => { if (this.isConnected) this.invalidate(); });
        this.measure();
        this.draw();
      }
      measure() {
        const viewport = Math.max(1, window.innerHeight);
        const wallTop = this.wall.parentElement.getBoundingClientRect().top;
        const revealTop = this.reveal.getBoundingClientRect().top;
        const margin = parseFloat(getComputedStyle(this.reveal).scrollMarginTop) || 0;
        this.landingInset = margin;
        this.travel = Math.max(1, revealTop - wallTop + viewport * .12 - margin);
        this.needsMeasure = false;
      }
      draw() {
        if (this.dataset.cinematic !== 'true' || this.reduced.matches) {
          this.setFrame(1, 1, 1, 0); return;
        }
        const clamp = x => Math.max(0, Math.min(1, x));
        const smooth = x => x * x * (3 - 2 * x);
        const heroTop = this.reveal.getBoundingClientRect().top;
        const progress = clamp(1 - (heroTop - this.landingInset) / this.travel);
        const wallProgress = smooth(clamp(progress / .72));
        const garageProgress = smooth(clamp((progress - .3) / .7));
        // Keep the editorial delay, but never strand the message at zero opacity.
        // One live rectangle also handles nested preview scrollers and late layout changes.
        const viewport = Math.max(1, window.innerHeight);
        const visibleProgress = smooth(clamp((viewport * .85 - heroTop) / (viewport * .45)));
        const timelineCopy = smooth(clamp((progress - .8) / .2));
        const copyProgress = window.Shopify?.designMode ? 1 : Math.max(timelineCopy, visibleProgress);
        const wallAmount = this.mobile.matches ? .04 : .07;
        const garageAmount = this.mobile.matches ? .05 : .1;
        this.setFrame(1 - wallAmount * wallProgress,
          1 + garageAmount * (1 - garageProgress), copyProgress, 8 * (1 - copyProgress));
      }
      setFrame(wall, garage, opacity, y) {
        // Progressive enhancement: if geometry fails, retain readable HTML content.
        if (![wall, garage, opacity, y].every(Number.isFinite)) {
          wall = 1; garage = 1; opacity = 1; y = 0;
        }
        this.wall.style.setProperty('--stw-wall-scale', wall.toFixed(4));
        this.reveal.style.setProperty('--stw-garage-scale', garage.toFixed(4));
        this.reveal.style.setProperty('--stw-copy-opacity', opacity.toFixed(4));
        this.reveal.style.setProperty('--stw-copy-y', `${y.toFixed(2)}px`);
        this.reveal.style.setProperty('--stw-copy-events', opacity > .05 ? 'auto' : 'none');
      }
      disconnectedCallback() {
        this.abort?.abort(); this.abort = null;
        this.resizeObserver?.disconnect(); this.intersectionObserver?.disconnect();
        cancelAnimationFrame(this.frame); this.frame = 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
